import { toast } from "react-toastify";

export const showToast = (text: string, type: "success" | "error" | "info" | "warning") =>
    toast(text, {
        className: `toast toast${type[0].toUpperCase() + type.slice(1)}`,
    });

export const showPromiseToast = <T>(promise: Promise<T>, onSuccess: string): Promise<T> =>
    toast.promise(promise, {
        pending: "Wait...",
        success: onSuccess,
        error: "Error",
    }) as Promise<T>;
